import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-apply-discount-code-response-modal',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './apply-discount-code-response-modal.component.html',
  styleUrl: './apply-discount-code-response-modal.component.scss'
})
export class ApplyDiscountCodeResponseModalComponent {

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<ApplyDiscountCodeResponseModalComponent>
  ) {}

  closeModal() {
    this.dialogRef.close();
  }
}
